import gql from "graphql-tag";

export const setProjectOnboardingEventCompleted = gql`
  mutation SetProjectOnboardingEventCompleted($input: SetProjectOnboardingEventCompletedRequestInput) {
    SetProjectOnboardingEventCompleted(input: $input) {
      success
    }
  }
`;
